import React from 'react';
import { Container, Row, Col } from '@yme/atoms/grid';
import { Image as ImageAtom } from '@yme/atoms/image';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { HeroComponentStyled, ImageBgStyled, ImageMaskStyled } from './styled';
export function HeroSectionContent(props) {
    const { backgroundImage, children } = props;
    return (React.createElement(HeroComponentStyled, null,
        React.createElement(ImageBgStyled, null,
            React.createElement(ImageAtom, { ...backgroundImage }),
            React.createElement(ImageMaskStyled, null)),
        React.createElement(Container, { height: "100%" },
            React.createElement(Row, { height: "100%" },
                React.createElement(Col, { lg: 8 },
                    React.createElement(FlexWrapper, { flexDirection: "column", justifyContent: "flex-end", pt: "16px", pbDesktop: "48px", pbTablet: "24px", pb: "16px", height: "100%" }, children))))));
}
HeroSectionContent.displayName = 'HeroSectionContent';
